<script>
  import { file2base64 } from "./utils.js";

  export let id;
  export let files;
  export let loading;

  let obj;
  let processed = [];

  let w;
  let width;

  let zoomed;

  let setting = false;

  $: w, setWidth();

  const setWidth = () => {
    if (w) width = w;
  }

  const processFiles = async fs => {
    const loadingId = loading.init('Loading tokens', fs.length)
    const objs = []
    for (const file of fs) {
      objs.push(
        file.type.startsWith('image') ?
        ({ name: file.name, img: await file2base64(file) }) :
        file
      );
      loading.inc(loadingId);
    }
    processed = [ ...objs, ...processed ];
    loading.reset(loadingId);
  }
  const set = async () => {
    setting = true;
    files = obj.files;
    await processFiles(files);
    setting = false;
  }
  const drop = async e => {
    setting = true;
    files = e.dataTransfer.files;
    await processFiles(files);
    setting = false;
  }
</script>

<div { id } class="lt-folder-input">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div class="drop" on:click={ () => { obj.click() } } on:drop|preventDefault={ drop } on:dragover|preventDefault>
    {#if setting}
      <span class="icon"><slot name="setting-icon">&#10227;</slot></span>
      <span>Setting files...</span>
    {:else}
      <span class="icon"><slot name="drop-icon">&#9729;</slot></span>
      <span>Drop files or click to select</span>
    {/if}
    <input type="file" multiple bind:this={ obj } on:change={ set } />
  </div>
  <div class="files" bind:offsetWidth={ w } style={ width ? `width: ${ width }px;` : undefined }>
    {#each processed as file}
      {#if file instanceof Blob}
        { file.name }
      {:else}
        <div class="image">
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
          <img src={ file.img } alt={ file.name } on:click={ e => { e.target.requestFullscreen() } } />
        </div>
      {/if}
    {/each}
  </div>
</div>